import { gql } from "@apollo/client";

export default gql`
  mutation RemoveMergeDevIntegration($integrationId: Int!) {
    removeMergeDevIntegration(integrationId: $integrationId) {
      success
      error
    }
  }
`;
